<template>
  <el-dialog title="统计" :visible.sync="dialogVisible" width="70vw" append-to-body :close-on-click-modal="false" top="5vh" >
    <el-tabs v-model="activeIndex">
      <el-tab-pane  v-for="(item,index) in urls_"  :label=" item.label" :name="index.toString()"  :key="index">
        <iframe :src="goview_url+item.id" style="width:100%;height:65vh;border-radius: 10px;" frameborder=0  ></iframe>
      </el-tab-pane>
    </el-tabs>
    <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="handleOpenLink">详细</el-button>
          <el-button @click="close">关闭</el-button>
        </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'SdOlMapIndex',

  data() {
    return {
      urls_:[],
      dialogVisible:false,
      activeIndex:'',
      digits_ : [ '一', '二', '三', '四', '五', '六', '七', '八', '九','十'],
      goview_url:''
    };
  },

  created() {
    const url = window.GoView?.url || ''
    this.goview_url = url + 'chart/preview/'
  },
  mounted() {
    
  },

  methods: {
    handleOpenLink(){
      window.open(this.goview_url+ this.urls_[this.activeIndex].id)
    },
    open(urls){
      this.urls_ = urls
      this.dialogVisible = this.urls_ && this.urls_.length > 0
      if (this.dialogVisible) {
        this.activeIndex = '0'
      }
    },
    close(){
      this.dialogVisible = false
    }
  },
};
</script>

<style scoped>
::v-deep .el-tab-pane{
  padding:0 5px;
}
</style>